import React from 'react';
import { isServer } from '@gik/core/utils/environment';
import ErrorBoundary from '../ErrorBoundary';
import { APIError } from '../../utils/error';
import { useDevStore } from '@gik/core/store/DevStore';

export default function withSuspense<P, R>(
  WrappedComponent: React.FC<P>,
  Fallback?: React.FC<P>,
  ErrorFallback?: React.FC<{ errors: APIError[] }>
) {
  function WrappedWithSuspense(props: P, ref: React.Ref<R>) {
    const fallback = Fallback ? <Fallback {...(props as P)} /> : <div>test</div>;
    const forceSkeleton = useDevStore(state => state.skeleton);

    let errorFallback = ErrorFallback;
    if (!errorFallback) {
      errorFallback = () => fallback;
    }

    return (
      <>
        {!isServer && !forceSkeleton ? (
          <ErrorBoundary fallback={errorFallback}>
            <WrappedComponent {...(props as P)} ref={ref} />
          </ErrorBoundary>
        ) : (
          fallback
        )}
      </>
    );
  }

  return React.forwardRef<R, P>(WrappedWithSuspense);
}
